import { Finding, Severity, FindingStatus, SEVERITY_ORDER } from './types';

export type SortColumn = 'title' | 'severity' | 'date' | 'status' | 'component_name';
export type SortDirection = 'asc' | 'desc';

export function sortFindings(
  findings: Finding[],
  column: SortColumn,
  direction: SortDirection,
): Finding[] {
  const sorted = [...findings].sort((a, b) => {
    let cmp: number;
    if (column === 'severity') {
      cmp = SEVERITY_ORDER.indexOf(a.severity) - SEVERITY_ORDER.indexOf(b.severity);
    } else {
      const va = a[column] ?? '';
      const vb = b[column] ?? '';
      cmp = String(va).localeCompare(String(vb));
    }
    return direction === 'asc' ? cmp : -cmp;
  });
  return sorted;
}

export function filterFindings(
  findings: Finding[],
  severityFilter?: Severity,
  statusFilter?: FindingStatus,
): Finding[] {
  return findings.filter(f => {
    if (severityFilter && f.severity !== severityFilter) return false;
    if (statusFilter && f.status !== statusFilter) return false;
    return true;
  });
}

export const PAGE_SIZE = 25;

export function paginateFindings(
  findings: Finding[],
  page: number,
): Finding[] {
  const start = page * PAGE_SIZE;
  return findings.slice(start, start + PAGE_SIZE);
}

export function totalPages(count: number): number {
  return Math.ceil(count / PAGE_SIZE);
}
